import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { basketBannerVehicleImageClickEvent } from "../banner/banner-analytics";
import HoldingImage from "../holding-image/holding-image";
export function Image(param) {
    var className = param.className, src = param.src, alt = param.alt, lazy = param.lazy, sendDigitalDataEvent = param.sendDigitalDataEvent, _clickable = param.clickable, clickable = _clickable === void 0 ? false : _clickable;
    var ref = useState(false), hasError = ref[0], updateErrorState = ref[1];
    var updateError = function() {
        updateErrorState(true);
    };
    var defaultImageProps = {
        className: className,
        src: src,
        alt: alt || "Image",
        loading: lazy ? "lazy" : "eager",
        onError: updateError
    };
    var imageProps = clickable ? _object_spread_props(_object_spread({}, defaultImageProps), {
        "aria-hidden": true,
        onClick: function() {
            return sendDigitalDataEvent(basketBannerVehicleImageClickEvent());
        }
    }) : defaultImageProps;
    var imageSrc = imageProps.src, imageAlt = imageProps.alt, restImageProps = _object_without_properties(imageProps, [
        "src",
        "alt"
    ]);
    return !src || hasError ? /*#__PURE__*/ _jsx(HoldingImage, {
        className: className,
        text: "Image Unavailable"
    }) : /*#__PURE__*/ _jsx("img", _object_spread({
        src: imageSrc,
        alt: imageAlt
    }, restImageProps));
}
export default Image;
